import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IWordsIncludeTagType = 'advanced-wordsInclude';

export interface IWordsIncludeTag {
  type: 'advanced-wordsInclude';
  value: string;
}

function isWordsIncludeTag(tag: TTag): tag is IWordsIncludeTag {
  return tag.type === IWordsIncludeTagType;
}

export const wordsIncludeTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.description_include && jsonQuery.description_include.value;

    let nextTags = tags.filter(
      tag => tag.type !== IWordsIncludeTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: string) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IWordsIncludeTag => isWordsIncludeTag(tag) && tag.value === value,
            previousTag => ({ type: IWordsIncludeTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
